import React from 'react';
import { Link } from '@material-ui/core';

import { MailLinkProps } from './MailLink.types';

export const MailLink: React.FC<MailLinkProps> = ({ children, mailto }) => (
  <Link href={`mailto:${mailto}`}>{children}</Link>
);
